import { DistributorMap } from './DistributorMap';
import {
  handleDistributorSearch,
  handleDistributorSearchFilterDisabling,
} from './distributor-handle-search';
import { handleDistributorZeroSearch } from './distributor-handle-zero-search';
import { getDistributorSettings } from './distributor-get-settings';
import { onDomReady } from '../on-dom-ready';
import type Usercentrics from '@usercentrics/cmp-browser-sdk';

declare global {
  interface Window {
    /**
     * Will be set to true by the google maps load callback.
     */
    googleMapsLoaded?: true;

    /**
     * Is set by this module if google maps hasn't been loaded yet so that the
     * google maps load callback can notify this module on load completion.
     */
    internalGoogleMapsInitializeCallback?: () => void;

    UC_UI?: Usercentrics & {
      /**
       * @see {@link https://docs.usercentrics.com/#/v2-events?id=app-initialization-browser-ui}
       */
      isInitialized(): boolean;
    };
  }
}

const initialize = () => {
  const mapElement = document.getElementById('distributor-search');
  if (mapElement === null) {
    return;
  }

  if (!window.googleMapsLoaded) {
    if (window.UC_UI?.isInitialized() !== true) {
      window.addEventListener('UC_UI_INITIALIZED', initialize);
    } else {
      // Create fake google maps instance for special uc-embed to show up.
      new window.google.maps.Map(
        mapElement,
        getDistributorSettings(mapElement),
      );
    }
    window.internalGoogleMapsInitializeCallback = initialize;
    return;
  }

  if (
    typeof window.google !== 'object' ||
    typeof window.google.maps !== 'object'
  ) {
    console.warn("Google Maps not found. Map won't show up!");
    return;
  }

  const map = new DistributorMap(
    mapElement,
    getDistributorSettings(mapElement),
  );

  const form = document.querySelector<HTMLFormElement>(
    'form#distributor-search-filter',
  );

  /**
   * Interaction handlers
   */
  form!!.addEventListener('change', () => handleDistributorSearch(map));
  form!!.addEventListener('submit', (event) => {
    event.preventDefault();
    handleDistributorSearch(map);
  });

  handleDistributorSearchFilterDisabling();

  // Request access to browsers location
  if ('geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition((position) => {
      // Set Own Position Marker
      map.updateOwnPositionMarker(
        new window.google.maps.LatLng(
          position.coords.latitude,
          position.coords.longitude,
        ),
      );
      handleDistributorZeroSearch(map, position.coords);
    });
  }
};

onDomReady(initialize);
